module.exports = __webpack_public_path__ + "static/img/WRC8.8aaa426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/WRC8/intro/WRC8.jpg
// module id = S4Rv
// module chunks = 0